import React, { Component } from "react";
import FirebaseLogin from "../../../components/FirebaseLogin";
import LinkButton from "../../../components/LinkButton";
import { Icon } from "semantic-ui-react";
import { Link } from "redux-little-router";

class Footer extends Component {
  render() {
    return (
      <footer className="footer-bg">
        <section className="-pre-links">
          <h2>Join the #1 Social Network for Dentists</h2>
          <FirebaseLogin className="-join">
            <Icon name="facebook f" />
          </FirebaseLogin>

          <LinkButton href="/signup" className="-primary" value="Create new account" />
        </section>

        <div className="-footer-links-wrapper">
          <div className="-left">
            <Link href="/sections/tos">Terms of Service</Link>
            <span>{"  -  "}</span>
            <Link href="/sections/privacy">Privacy Policy</Link>
            <span>{"  -  "}</span>
            <Link href="/sections/content-policy">Content Policy</Link>
            <span>{"  -  "}</span>
            <Link href="/sections/tos-appendix">TOS Appendix</Link>
          </div>
          <div className="-apps">
            <p className="-download-title">Download our APP</p>
            <a
              href="https://itunes.apple.com/us/app/casemasters/id1326535330"
              className="-apple"
              title="Download for iOS"
            >
              <Icon name="apple" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.casemasters.android&hl=en"
              className="-android"
              title="Download for Android"
            >
              <Icon name="android" />
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/Footer.js